module.exports = __webpack_public_path__ + "img/ic-logo-eostre@2x.f82dd3f3.jpg";